import agent from '@/utils/request/agent'

/**
 * 获取推送消息列表
 * @param {Object} params - 查询参数（可选）
 * @param {string} params.appId - 应用ID
 * @param {string} params.userId - 用户ID
 * @param {number} params.page - 页码，默认为 1
 * @param {number} params.pageSize - 每页大小，默认为 20
 * @param {string} params.types - 消息类型，可选值：'alert' | 'task' | 'reminder' | 'notification'
 * @returns {Promise} 返回消息列表数据
 */
export function getPushMessages(params = {}) {
  const { appId = 'eMind', userId, page = 1, pageSize = 20, types } = params

  const requestParams = {
    page,
    pageSize
  }

  // 如果指定了 types，添加到查询参数
  if (types) {
    requestParams.types = types
  }

  return agent({
    url: '/api/push/messages',
    method: 'get',
    params: requestParams,
    headers: {
      'X-App-Id': appId,
      'X-User-Id': userId
    }
  })
}

/**
 * 确认消息已读
 * @param {Object} params - 请求参数
 * @param {string} params.messageId - 消息ID
 * @param {string} params.action - 操作类型，默认为 'read'
 * @param {string} params.appId - 应用ID
 * @param {string} params.userId - 用户ID
 * @returns {Promise} 返回确认结果
 */
export function ackMessage(params = {}) {
  const { messageId, action = 'read', appId = 'eMind', userId } = params

  return agent({
    url: '/api/push/ack',
    method: 'post',
    headers: {
      'X-App-Id': appId,
      'X-User-Id': userId
    },
    data: {
      messageId,
      action
    }
  })
}
